var lib_geometry = require("lib-geometry");
var PthPadstackData = require("./../padstack/pthPadstackData.js");
var SmdPadstackData = require("./../padstack/smdPadstackData.js");

var PadToMesh = function(){

    this.mesh = this.deepCachedFunction("mesh",
        function (info) {
            if (!this.padstack()) return null;

            if (this.padstack() instanceof PthPadstackData) {
                var precision = (info && info.copperPrecision)? info.copperPrecision : 3;
                var holePrecision = (info && info.holePrecision)? info.holePrecision : 3;
                var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;
                var boardThickness = (info && info.boardThickness)? info.boardThickness : 2;
                var holes = (info && info.holes)? info.holes : [];

                var myhole = this.getDrillSegmentedGeometry(precision);
                //var allholes = holes.concat(hole);
                var topGeom = (holes.length == 0) ? this.segmentedGeometry(precision) : lib_geometry.Union([this.segmentedGeometry(precision)], holes);
                var topPad = (new lib_geometry.TriangleMesh()).fromPolygon(topGeom, copperHeight);
                
                if(topPad.isEmpty()) return new lib_geometry.TriangleMesh();

                var middleMesh = null;

                if (myhole) {
                    var middleGeom = myhole.close().toOutlineGeometry(copperHeight * 2, 2);
                    middleGeom = lib_geometry.Union([middleGeom], holes);
                    var extrude = this.parent().boardThickness + copperHeight * 2;
                    var middleMesh = (new lib_geometry.TriangleMesh()).fromPolygon(middleGeom, extrude);
                    middleMesh = middleMesh.translate(0,0, -boardThickness - copperHeight);
                }


                // var bottomPad = topPad.clone().translate(0,0, -boardThickness - copperHeight);
                var bottomGeom = (holes.length == 0) ? this.getBottomSegmentedGeometry(precision) : lib_geometry.Union([this.getBottomSegmentedGeometry(precision)], holes);
                var bottomPad = (new lib_geometry.TriangleMesh()).fromPolygon(bottomGeom, copperHeight);
                bottomPad.translate(0,0, -boardThickness - copperHeight);

                if (middleMesh && !middleMesh.isEmpty()) {
                    return topPad.mergeMesh(bottomPad).mergeMesh(middleMesh);
                } else {
                    return topPad.mergeMesh(bottomPad);
                }
            }
            else if (this.padstack() instanceof SmdPadstackData) {
                var precision = (info && info.copperPrecision)? info.copperPrecision : 3;
                var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;
                var holes = (info && info.holes)? info.holes : [];
                var boardThickness = (info && info.boardThickness)? info.boardThickness : 2;

                var geom = this.segmentedGeometry(precision);
                var cutGeom = lib_geometry.Union([geom], holes);
                var geom3d = (new lib_geometry.TriangleMesh()).fromPolygon(cutGeom, copperHeight);
                if(!this.onTopLayer()){
                    geom3d.translate(0,0, -boardThickness - copperHeight);
                }
                return geom3d;
            }
        },
        [this.segmentedGeometry], 1
    );
}


module.exports = PadToMesh;

